import Cookies from 'js-cookie';

const AUTH_KEYS = ['ct', 'ut', 'uid', 'sessionId'];
const PATHS = ['/', '/qn', '/qn/'];

function isLocalDevHost(host) {
    return host === 'localhost' || host === '127.0.0.1' || /^(\d{1,3}\.){3}\d{1,3}$/.test(host);
}

/**
 * 根据当前 host 决定 cookie domain
 * 本地 dev server（localhost / IP / yarn dev）仅使用 host-only cookie
 * @returns {string|undefined}
 */
export function getCookieDomain() {
    const host = window.location.hostname;
    if (process.env.NODE_ENV === 'development' || isLocalDevHost(host)) {
        return undefined;
    }
    if (host.endsWith('eastmoney.com')) {
        return '.eastmoney.com';
    }
    if (host.endsWith('dfcfs.cn')) {
        return '.dfcfs.cn';
    }
    return undefined;
}

function getRemoveDomains() {
    const host = window.location.hostname;
    const parentDomain = getCookieDomain();
    const domains = [undefined, host];
    if (parentDomain) {
        domains.push(parentDomain);
    }
    return [...new Set(domains)];
}

function removeCookieWithOptions(name, options) {
    Cookies.remove(name, options);
    Cookies.set(name, '', { ...options, expires: -1 });
}

/**
 * 清理所有可能的 ct/ut/uid/sessionId 残留（覆盖不同 domain/path 组合）
 */
export function removeAuthCookies() {
    const domains = getRemoveDomains();
    AUTH_KEYS.forEach(name => {
        domains.forEach(domain => {
            PATHS.forEach(path => {
                const options = { path };
                if (domain) {
                    options.domain = domain;
                }
                removeCookieWithOptions(name, options);
            });
        });
    });
}

/**
 * 统一写入认证 cookie：先清理再按固定 domain/path 写入
 * @param {{ ct?: string, ut?: string, uid?: string, sessionId?: string }} tokens
 */
export function setAuthCookies({ ct, ut, uid, sessionId } = {}) {
    removeAuthCookies();

    const options = { expires: 1, path: '/' };
    const domain = getCookieDomain();
    debugger;
    if (domain) {
        options.domain = domain;
    }

    if (ct) {
        Cookies.set('ct', ct, options);
    }
    if (ut) {
        Cookies.set('ut', ut, options);
    }
    if (uid) {
        Cookies.set('uid', uid, options);
    }
    if (sessionId) {
        Cookies.set('sessionId', sessionId, options);
    }
}
